import { Resource as ResourceType } from '../types';

export const creditNotes: ResourceType = {
  name: 'credit_notes',
  label: 'resource.credit_notes.label',
  hideResource: false,
  attributes: [
    {
      key: 'id',
      type: 'text',
      label: 'resource.invoices.field.id.label',
    },
    {
      key: 'guid',
      type: 'text',
      label: 'resource.credit_notes.field.guid.label',
    },
    {
      key: 'company_name',
      type: 'text',
      label: 'resource.invoices.field.company_name.label',
    },
    {
      key: 'total_ht',
      type: 'number',
      label: 'resource.credit_notes.field.total_ht.label',
    },
    {
      key: 'contract_milestone_title',
      type: 'translatedText',
      label: 'resource.contract_milestones.label',
    },
    {
      key: 'total_ttc',
      type: 'number',
      label: 'resource.credit_notes.field.total_ttc.label',
    },
    {
      key: 'client_platform_deposit',
      label: 'resource.credit_notes.field.client_platform_deposit.label',
      type: 'boolean',
    },
    {
      key: 'created_at',
      type: 'date',
      label: 'resource.credit_notes.field.created_at.label',
    },
    {
      key: 'invoice_id',
      label: 'resource.credit_notes.field.invoice.label',
      type: 'reference',
      reference: 'invoices',
    },
    {
      key: 'contract_milestone_id',
      label: 'resource.invoices.field.contract_milestone_id.label',
      type: 'reference',
      reference: 'contract_milestones',
    },
    {
      key: 'pdfs',
      label: 'resource.credit_notes.field.pdf.label',
      type: 'buttons',
    },
  ],
  pages: {
    list: {
      hasEditButton: true,
      search: {
        enabled: true,
        label: 'filter.search.label',
      },
      filters: [
        {
          source: 'created_at',
          type: 'dateRange',
          label: 'resource.invoices.field.credit_note.label',
        },
        {
          source: 'client_platform_deposit',
          type: 'boolean',
          label: 'resource.credit_notes.field.client_platform_deposit.label',
        },
      ],
      fields: [
        { source: 'guid' },
        { source: 'company_name' },
        {
          source: 'invoice_id',
          type: 'reference',
          link: true,
          reference: 'invoices',
          child: {
            type: 'text',
            source: 'invoices.guid',
          },
        },

        { source: 'total_ht' },
        { source: 'total_ttc' },
        { source: 'client_platform_deposit' },
        { source: 'created_at' },
        {
          source: 'pdfs',
          sortable: false,
          extensions: [
            {
              key: 'multipleLangFiles',
            },
          ],
        },
        {
          source: 'contract_milestone_id',
          type: 'reference',
          link: true,
          child: {
            source: 'contract_milestones.title',
            type: 'translatedText',
          },
        },
      ],
      bulkActionButtons: [
        {
          name: 'deposit_made',
          type: 'update',
          label:
            'resource.credit_notes.bulk_action_buttons.client_platform_deposit.label',
          values: {
            client_platform_deposit: true,
          },
        },
      ],
    },
    edit: {
      singleRedirect: {
        page: 'edit',
        basePath: '/credit_notes',
        recordId: 'id',
      },
      left: {
        tabs: [
          {
            key: 'information',
            title: '',
            sections: [
              {
                key: 'details',
                title: 'resource.credit_notes.section.details.title',
                layout: [
                  ['guid'],
                  ['contract_milestone_title'],
                  ['total_ht', 'total_ttc'],
                  ['client_platform_deposit'],
                ],
                inputs: {
                  guid: { disabled: true, validators: [{ key: 'required' }] },
                  total_ht: { disabled: true },
                  total_ttc: { disabled: true },
                  client_platform_deposit: {
                    width: 6,
                    rules: {
                      hide: [
                        {
                          property: 'user_kind',
                          op: 'eq',
                          value: 'expert',
                        },
                      ],
                    },
                  },
                },
              },
              {
                key: 'download',
                title: 'resource.invoices.section.download.title',
                layout: [['pdfs']],
                inputs: {},
                fields: {
                  pdfs: {
                    addLabel: true,
                    extensions: [
                      {
                        key: 'multipleLangFiles',
                      },
                    ],
                  },
                },
              },
            ],
          },
        ],
      },
      right: [
        {
          sections: [
            {
              key: 'details',
              title: 'resource.invoices.section.infos.title',
              layout: [['id'], ['created_at']],
              inputs: {
                id: {
                  disabled: true,
                },
                created_at: {
                  disabled: true,
                },
              },
              fields: {},
            },
          ],
        },
        {
          sections: [
            {
              key: 'links',
              title: 'resource.invoices.section.links.title',
              layout: [['contract_milestone_id', 'invoice_id']],
              inputs: {},
              fields: {
                contract_milestone_id: {
                  addLabel: true,
                  child: {
                    source: 'contract_milestones.title',
                    type: 'translatedText',
                  },
                },
                invoice_id: {
                  addLabel: true,
                  link: true,
                  child: {
                    type: 'text',
                    source: 'invoice.guid',
                  },
                },
              },
            },
          ],
        },
      ],
    },
  },
};
